import { render, staticRenderFns } from "./storedbalanceDetail.vue?vue&type=template&id=7079e453"
import script from "./storedbalanceDetail.vue?vue&type=script&lang=js"
export * from "./storedbalanceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports